import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NbToastrService } from '@nebular/theme';
import { MasterService } from '../../@core/services/master.service';

@Component({
  selector: 'ngx-dashboard-admin',
  templateUrl: './dashboard-admin.component.html',
  styleUrls: ['./dashboard-admin.component.scss']
})
export class DashboardAdminComponent implements OnInit {
  registerForm: FormGroup;
  userDetails: any[] = [];
  userType: string = 'manager';
  isEditMode = false;
  editIndex: number | null = null;
  editUserData: any;
  showConfirmPassword = false;
  role_id: any;
  managersList = [];
   

  getAllrolesData: string[] = [];
  getAllUsersData: string[] = [];


  ngOnInit(): void {
    let role_name = sessionStorage.getItem('role');

    console.log('role_name in storage', role_name)


    this.masterService.get_All_roles({}).subscribe((res: any) => {
      this.getAllrolesData = res['data'];
      console.log('this.getAllrolesData', this.getAllrolesData);

      let matched_Obj: any = this.getAllrolesData.find((ele: any) => ele.role_name == role_name)

      this.role_id = matched_Obj.role_id;
      console.log('matched_Obj', matched_Obj);

      this.masterService.add_user({
        "action": "SELECT"
        //  "role_id":2
      }).subscribe((res: any) => {
        this.getAllUsersData = res['data'];
        this.userDetails = this.getAllUsersData;

        this.managersList = this.userDetails.filter((ele: any) => ele.role_id == 2)
        console.log('getAllUsers', this.getAllUsersData);

      })


    })




    // this.registerForm = this.fb.group({
    //   role_id: ['Manager', Validators.required],
    //   first_name: ['', Validators.required],
    //   last_name: ['', Validators.required],
    //   email: ['', [Validators.required, Validators.email]],
    //   phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
    //   password_hash: ['', [Validators.required, Validators.minLength(6)]],
    //   confirmPassword: [''],
    //   reportingManager: [''],
    //   username : ['', Validators.required],
    // }
    // , { validators: this.passwordMatchValidator });

    this.registerForm = this.fb.group({
      role_id: ['Manager', Validators.required],
      first_name: ['', Validators.required],
      last_name: ['', Validators.required],
      // email: ['', [Validators.required, Validators.email]],
      // phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      // password_hash: ['', [Validators.required, Validators.minLength(6)]],
      confirmPassword: [''],
      reportingManager: [''],
      
      username: ['', Validators.required],

      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.pattern(/^\d{10}$/)]], // Optional but must be 10 digits if entered
      password_hash: ['', [Validators.required, Validators.minLength(6)]],
    }
    );




    this.updateReportingManagerValidation();

    // console.log('role_id', this.role_id);

    // this.getAllUsers()

  }

  constructor(private fb: FormBuilder,
    private notify: NbToastrService, private masterService: MasterService
  ) {
    // this.registerForm = this.fb.group({
    //   role_id: ['Manager', [Validators.required]], 
    //   first_name: ['', [Validators.required, Validators.pattern(/^\S.*\S$/)]],
    //   last_name: ['', [Validators.required, Validators.pattern(/^\S.*\S$/)]],
    //   email: ['', [Validators.required, Validators.email]],
    //   // phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]], 
    //   phone: ['', [Validators.pattern(/^\d{10}$/)]],
    //   password_hash: ['', [Validators.required, Validators.minLength(6)]],
    //   confirmPassword: ['', [Validators.required]],
    //   reportingManager: ['', [Validators.required]],
    // }, { validator: this.passwordMatchValidator });
  }

  // Function to update role_id on button click
  setRole(role_id: string) {
    this.registerForm.patchValue({
      "role_id": role_id
    });
  }

  getAllUsers() {

    let matched_role_id: any = this.getAllrolesData.find((ele: any) => ele.role_name == this.role_id);
    console.log('matched_role_id', matched_role_id)
    this.masterService.add_user({
      "action": "SELECT",
      "role_id": matched_role_id.role_id
    }).subscribe((res: any) => {
      this.getAllUsersData = res['data'];
      this.userDetails = this.getAllUsersData
      console.log('getAllUsers', this.getAllUsersData);

    })
  }


  isUsernameTaken: boolean = false;

  checkUsernameExists() {
    const enteredUsername = this.registerForm.get('username')?.value?.trim();
    this.isUsernameTaken = this.userDetails.some(user => user.username === enteredUsername);
  }


  updateReportingManagerValidation() {
    // debugger
    if (this.registerForm.get('role_id')?.value === 'Engineer') {
      this.registerForm.get('reportingManager')?.setValidators(Validators.required);
    } else {
      this.registerForm.get('reportingManager')?.clearValidators();
      this.registerForm.patchValue({ reportingManager: '' });
    }
    this.registerForm.get('reportingManager')?.updateValueAndValidity();
  }

  // Password match validation
  passwordMatchValidator(form: FormGroup) {
    return form.get('password_hash')!.value === form.get('confirmPassword')!.value ? null : { mismatch: true };
  }

  // Trim input values when user types
  trimInput(field: string) {
    const value = this.registerForm.get(field)!.value;
    if (value) {
      this.registerForm.get(field)!.setValue(value.trim(), { emitEvent: false });
    }
  }

  // Toggle between Manager & Engineer
  toggleUserType(type: string) {
    this.userType = type;
  }

  // Register user
  // register() {
  //   if (this.registerForm.valid) {
  //     const userData = this.registerForm.value;

  //     if (this.isEditMode && this.editIndex !== null) {
  //       // Update existing row
  //       this.userDetails[this.editIndex] = userData;
  //       this.isEditMode = false;
  //       this.editIndex = null;
  //     } else {
  //       // Add new user
  //       this.userDetails.push(userData);
  //     }

  //     console.log('User Details', this.userDetails);
  //     this.registerForm.reset();
  //     this.registerForm.patchValue({ 
  //       "role_id" : 'Manager' 
  //     });
  //   } else {
  //     console.log('Form Invalid');
  //   }
  // }
  register() {



    if (this.registerForm.valid) {
      const userData = this.registerForm.value;

      let matched_Obj: any = this.getAllrolesData.find((ele: any) => ele.role_name == userData.role_id)
      this.role_id = matched_Obj.role_id;

      // Check if role_id is Engineer and reportingManager is empty
      if (userData.role_id === 'Engineer' && !userData.reportingManager) {
        this.registerForm.get('reportingManager')?.setErrors({ required: true });
        this.registerForm.get('reportingManager')?.markAsTouched();
        console.log('Reporting Manager is required for Engineer');
        this.notify.warning('Reporting Manager is required for Engineer.');
        return;
      }

      if (this.isEditMode && this.editIndex !== null) {
        // Update existing row
        console.log('user updated data', userData)
        // this.userDetails[this.editIndex] = userData;
        this.isEditMode = false;
        this.editIndex = null;
        
        // debugger;
        let editUserObj: any = {
          "action": "UPDATE",
          "first_name": userData.first_name,
          "last_name": userData.last_name,
          "email": userData.email,
          "phone": userData.phone,
          "username": userData.username,
          "password_hash": userData.password_hash,
          "user_id": this.editUserData.user_id,
          "role_id": this.editUserData.role_id,
          // "manager_id": +(userData.reportingManager),
          "manager_id": userData.reportingManager ? Number(userData.reportingManager) : null,
          "manager_name": this.editUserData.manager_name,
          "engineer_id": this.editUserData.engineer_id,
          "engineer_name": this.editUserData.engineer_name,
          "role_name": this.editUserData.role_name,
        }

        console.log('editUserObj', editUserObj)

        this.masterService.add_user(editUserObj).subscribe((res: any) => {
          console.log('res user', res);

          if (res) {
            this.masterService.add_user({
              "action": "SELECT"
            }).subscribe((res: any) => {

              console.log('res in users', res)
              this.userDetails = res['data']

            })
          }
        })


      } else {

        let userObj = {
          "action": "INSERT",
          "role_id": matched_Obj.role_id,
          "user_id": null,
          "manager_id": userData.reportingManager ? Number(userData.reportingManager) : null,
          "engineer_id": null,
          "first_name": userData.first_name,
          "last_name": userData.last_name,
          "email": userData.email,
          "phone": userData.phone,
          "password_hash": userData.password_hash,
          "confirmPassword": userData.confirmPassword,
          // "reportingManager": userData.reportingManager,
          "username": userData.username,
          "role_name": userData.role_id,
        }

        console.log('userObj', userObj)


        this.masterService.add_user(userObj).subscribe((res: any) => {
          console.log('res user', res);

          if (res) {
            this.masterService.add_user({
              "action": "SELECT"
            }).subscribe((res: any) => {

              console.log('res in users', res)
              this.userDetails = res['data']

            })
          }
        })
        // console.log('userData', userObj)
        // this.userDetails.push(userObj);
      }

      console.log('User Details', this.userDetails);
      this.registerForm.reset();
      this.setRole('Manager'); // Reset form and default to Manager
    } else {
      console.log('Form Invalid');
    }
  }


  editRow(data: any, index: number) {
    this.isEditMode = true;
    this.editIndex = index;

    this.editUserData = { ...data };
    // this.registerForm.patchValue(this.userDetails[index]); // Populate form with row data


  let obj = {
    ...data,  // Spread all existing values from data (instead of this.userDetails[index])
    reportingManager: data.manager_id
  }
   this.registerForm.patchValue(obj);

    console.log('obj in edit', obj)
    this.setRole(data.role_name
    ); // Reset form and default to Manager

  }

  // Delete user
  deleteUser(data: any, index: number) {

    // console.log('deleted user', data)
    this.userDetails.splice(index, 1);
    let obj = {
      "action": "DELETE",
      "user_id": data.user_id

    }
    // console.log('deleted obj', obj)

    this.masterService.add_user(obj).subscribe((res: any) => {
      // console.log('deleted data ', res)
    })

  }


  togglePasswordVisibilityOld(field: string) {
    console.log('feild', field)
    this.showPassword = !this.showPassword;

    // if (field === 'password_hash') {
    //   this.showPassword = !this.showPassword;
    // } else if (field === 'confirmPassword') {
    //   this.showConfirmPassword = !this.showConfirmPassword;
    // }
  }
  // showPassword = false;

  // togglePasswordVisibility(input: HTMLInputElement) {
  //   this.showPassword = !this.showPassword;
    
  //   // Type assertion to avoid TypeScript error
  //  (input.style as any).webkitTextSecurity = this.showPassword ? 'none' : 'disc';
  // }

  showPassword = false; // Initially, the password is hidden

togglePasswordVisibility(input: HTMLInputElement) {
    this.showPassword = !this.showPassword;
    
    // Ensure text security matches the visibility state
    (input.style as any).webkitTextSecurity = this.showPassword ? 'none' : 'disc';
}

}